<template>
  <ul
    class="filter-ul"
    :style="{
      maxHeight: maxHeight,
    }"
  >
    <div class="px-5 py-2">
      <v-checkbox
        v-model="totalCheckbox"
        hide-details
        color="#3a6eff"
        :label="`전체`"
        @click="onCheckTotalYear"
      ></v-checkbox>
    </div>

    <v-list :v-model:opened="openedGroups">
      <v-list-group
        v-for="year in yearList"
        :key="year"
        color="black"
        no-action
        style="background-color: white;"
        :v-model="year"
      >
        <template v-slot:activator>
          <v-list-item-content class="px-5 font-14">
            <v-checkbox
              v-model="yearCheckList"
              :value="year"
              color="#3a6eff"
              hide-details
              @click.native.stop
              @change="onCheckYear(yearCheckList, year)"
            ></v-checkbox>
            {{ year }}년
          </v-list-item-content>
        </template>

        <v-list-item-content class="px-5 pb-2 pt-0 ">
          <div class="month-wrapper">
            <v-checkbox
              v-for="(month, monthIdx) in 12"
              :key="`${year}-${month}`"
              hide-details
              color="#3a6eff"
              :input-value="
                checkedMonths[year] && checkedMonths[year][monthIdx]
              "
              :disabled="
                checkedMonths[year] && checkedMonths[year][monthIdx] === null
              "
              @change="onCheckMonth(year, monthIdx)"
              :label="`${month}월`"
            ></v-checkbox>
          </div>
        </v-list-item-content> </v-list-group
    ></v-list>
  </ul>
</template>

<script>
export default {
  /** emit : onSelectYearMonth({ yearCheckList, checkedMonths }) */
  props: {
    yearList: { type: Array, default: () => {} },
    activeMonths: { type: Array, default: () => [] },
    maxHeight: { type: String, default: "268px", require: false },
    isDisabled: { type: Boolean, require: false },
  },
  data: () => ({
    totalCheckbox: true,
    yearCheckList: [],
    checkedMonths: {}, // 형태 : { 2024: [1, 2, 5], 2025: [3, 6], 2026: [] }
    openedGroups: [],
  }),
  watch: {
    yearList: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.initFilter();
        }
      },
    },
    yearCheckList(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.emitYearMonth();
      }
    },
  },
  created() {
    this.initFilter();
  },
  methods: {
    emitYearMonth() {
      const monthCheckList = Object.entries(this.checkedMonths)
        // eslint-disable-next-line no-unused-vars
        // .filter(([_, months]) => months.includes(false)) // false 1개라도 있는 연도만
        .flatMap(([year, months]) =>
          months
            .map((checked, idx) => {
              if (checked === true) {
                const month = String(idx + 1).padStart(2, "0");
                return `${year}-${month}`;
              }
              return null;
            })

            .filter(Boolean)
        );

      const data = {
        yearCheckList: null,
        checkedMonths: monthCheckList.length ? monthCheckList : null,
      };

      this.$emit("onSelectYearMonth", data);
    },
    // 연도별 월 리스트 만들기
    getFullYearsByMap(monthList) {
      const yearMonthMap = {};
      monthList.map((item) => {
        const [year, month] = item.split(".");
        if (!yearMonthMap[year]) {
          yearMonthMap[year] = new Set();
        }
        yearMonthMap[year].add(month.padStart(2, "0"));
      });

      // 연도별로 12개월이 다 있으면 해당 연도 반환
      return Object.entries(yearMonthMap)
        .map(([year, months]) => (months.size === 12 ? year : null))
        .filter(Boolean); // null 제거
    },
    initFilter() {
      // this.totalCheckbox = true;
      // this.yearCheckList = this.yearList;

      if (this.activeMonths?.length) {
        // disabled 처리하기 - null 세팅
        const activeMonths = new Set([...this.activeMonths]);
        this.checkedMonths = this.yearList.reduce((acc, year) => {
          acc[year] = Array.from({ length: 12 }, (_, i) => {
            const month = String(i + 1).padStart(2, "0");
            const key = `${year}.${month}`;
            const hasEmptyData = this.isDisabled ? null : false;
            return activeMonths.has(key) ? true : hasEmptyData; // 포함되어 있으면 true, 아니면 null (disabled는 안되게 하려면 false)
          });
          return acc;
        }, {});
        const yearChecked = this.getFullYearsByMap(this.activeMonths);
        const isAllYearChecked = yearChecked.length === this.yearList?.length;
        // isDisabled 이면 [전체/연도체크] 체크활성화
        this.totalCheckbox = this.isDisabled ? true : isAllYearChecked;
        this.yearCheckList = this.isDisabled ? this.yearList : yearChecked;
      } else {
        this.totalCheckbox = true;
        this.yearCheckList = this.yearList;

        this.checkedMonths = this.yearList?.reduce((acc, year) => {
          acc[year] = Array(12).fill(true);
          return acc;
        }, {});
      }
    },
    /** 전체 년도 체크 */
    onCheckTotalYear() {
      this.yearCheckList = this.totalCheckbox ? this.yearList : [];

      this.checkedMonths = this.yearList.reduce((acc, year) => {
        acc[year] = (this.checkedMonths[year] || []).map((val) => {
          // null이면 유지, 나머지는 전체 체크 상태로 덮어쓰기
          return val === null ? null : this.totalCheckbox;
        });
        return acc;
      }, {});
    },
    /** 개별 년도 체크 */
    onCheckYear(checkedYearList, year) {
      this.totalCheckbox = checkedYearList?.length === this.yearList?.length;

      const isCurChecked = this.yearCheckList.includes(year);

      // 기존 checkedMonths[year]이 있으면 유지하고, 없으면 true/false로 채움
      const updatedMonths = (this.checkedMonths[year] || []).map((val) =>
        val === null ? null : isCurChecked
      );
      this.$set(this.checkedMonths, year, updatedMonths);
    },
    /** 개별 월 체크 */
    onCheckMonth(year, monthIdx) {
      const isCurChecked = !this.checkedMonths[year][monthIdx];
      this.$set(this.checkedMonths[year], monthIdx, isCurChecked);

      if (!isCurChecked) {
        this.yearCheckList = this.yearCheckList.filter((y) => y !== year);
        this.totalCheckbox = false;
        return;
      }

      const isAllCheck = !this.checkedMonths[year].some((m) => m === false);
      if (isAllCheck) {
        this.yearCheckList = [...this.yearCheckList, year];
      }
      this.totalCheckbox = this.yearCheckList?.length === this.yearList?.length;

      this.emitYearMonth();
    },
  },
};
</script>

<style scoped lang="scss">
ul,
li {
  padding: 0;
  margin: 0;
}
/** v-list-group */
::v-deep .v-list-group .v-list-item {
  padding: 0px;
}
::v-deep .v-list-item--link:before {
  background-color: transparent !important;
}
/** v-checkbox */
::v-deep .v-input--selection-controls {
  margin-top: 0%;
  padding-top: 0px;
}
::v-deep .v-label {
  color: #222222;
  font-size: 14px;
}
/** v-checkbox 크기 */
::v-deep .v-input--selection-controls__input {
  .v-icon {
    font-size: 19px;
  }
}
::v-deep .v-input--selection-controls__ripple {
  height: 24px;
  width: 24px;
  left: -7px;
  top: calc(50% - 19px);
}
::v-deep .v-list-item__icon:last-of-type:not(:only-child) {
  margin-right: 16px;
}
.filter-ul {
  overflow-y: auto;
}
/** Scrollbar */
.filter-ul::-webkit-scrollbar {
  width: 8px;
}
.filter-ul::-webkit-scrollbar-thumb {
  background-color: #a5a5a5 !important;
  border-radius: 6px;
}
.filter-ul::-webkit-scrollbar-track {
  background-color: white !important;
}
.font-14 {
  font-size: 14px;
}
.filter-container {
  width: 272px;
  max-height: 318px;
  background-color: white;
}
.filter-titile {
  color: #666666;
  font-size: 14px;
  font-weight: 500;
}
.month-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 5px;
  border-radius: 5px;
  background: #f7f7f7;
  padding: 8px 16px 8px 16px;
  ::v-deep .v-label {
    font-size: 14px;
  }
  ::v-deep .v-label--is-disabled {
    color: #a5a5a5;
  }
}
.filter-btn {
  border-radius: 5px;
  background: #666666;
  color: white;
  padding: 4px 12px;
  font-size: 14px;
  &:hover {
    background: #797979;
    transition: 0.1s ease-in-out;
  }
}
</style>
